package com.xtream.data_kmp.db.utils

import kotlin.math.pow

/*


fun String.tryFormat(locale: Locale?, format: String,alt:String=""): String {
    return try {
        String.format(locale, format, this.toFloatOrNull())
    } catch (e: Exception) {
        alt
    }

}*/

/**
 * A basic KMP implementation for decimal formatting.
 * Note: This doesn't handle complex Locales automatically.
 */
fun String.tryFormat(digits: Int = 2, alt: String = ""): String {
    val value = this.toFloatOrNull() ?: return alt

    // Simple manual rounding for KMP commonMain
    val multiplier = 10.0.pow(digits)
    val rounded = (value * multiplier).toInt() / multiplier

    return rounded.toString()
}
